import * as React from "react";
import { Hint } from "react-ui";

import { useMetrics } from "../../../Internals/Metrics/MetricsProviderContext";
import { useTourStepRef } from "../../../Internals/TourManagement/UseTourStepRef";
import { PIN_CLICK } from "../../../metricsAction";
import { pinTourStep } from "../../Tour/Steps/Pin";

import { PinIcon, PinRoot } from "./Pin.styles";

interface PinProps {
    className?: string;
    expanded: boolean;
    pinned: boolean;
    onClick: () => void;
}

export function Pin(props: PinProps): JSX.Element {
    const track = useMetrics();
    const tourRef = useTourStepRef(pinTourStep);

    const handlePinClick = () => {
        track(PIN_CLICK, { pinState: props.pinned ? "unpinned" : "pinned" });
        props.onClick();
    };

    return (
        <Hint useWrapper={false} pos="bottom left" text={props.expanded ? "Свернуть меню" : "Закрепить меню"}>
            <PinRoot className={props.className} ref={tourRef} onClick={handlePinClick}>
                <PinIcon name="AttachPinIcon" size={16} pinned={props.pinned} />
            </PinRoot>
        </Hint>
    );
}
